<template>
  <Button size="sm" variant="secondary" class="w-[90px]">
    Filters <ChevronDownIcon class="ml-[2px] inline h-[14px] w-[14px]" />
  </Button>
</template>
